<template>
  <div id="app">
    <commonhead :active_menu="-1" :callback="authcallback" />
    <div class="user_center_order my_style myorder_style">
      <div class="content_wrap">
        <div class="current_title">订单中心</div>
        <div class="order_list">
          <Table
            :data="orderData.list"
            style="width: 100%"
            :header-cell-style="head_style"
            :cell-style="cell_style"
          >
            <TableColumn prop="created_at" label="订单时间" width="180"></TableColumn>
            <TableColumn prop="order_id" label="订单ID" width="180"></TableColumn>
            <TableColumn prop="address" label="状态">
              <template slot-scope="scope">{{scope.row.is_paid == 1 ? '已支付':'未支付'}}</template>
            </TableColumn>
            <TableColumn prop="money_amount" label="金额">
              <template slot-scope="scope">{{scope.row.money_amount+"人民币"}}</template>
            </TableColumn>
            <TableColumn prop="money_amount" label="支付方式">
              <template slot-scope="scope">{{scope.row.payment_method == 1 ? '支付宝':'微信'}}</template>
            </TableColumn>
            <TableColumn prop="address" label="内容">
              <template slot-scope="scope">{{deal_goods(scope.row.goods_type)}}</template>
            </TableColumn>
            <TableColumn label="操作" width="200">
              <template slot-scope="scope">
                <Button size="mini" class="btn_detail" type="success" @click="pay_now(scope.row.order_id,scope.row.is_paid)">详情</Button>
                <Button
                  size="mini"
                  type="danger"
                  @click="pay_now(scope.row.order_id,scope.row.is_paid)"
                  v-if="scope.row.is_paid == 0 && (now - new Date(scope.row.created_at.replace(/-/g,'/'))<5*60*1000)"
                >立即付款</Button>
              </template>
            </TableColumn>
          </Table>
          <!--分页器-->
          <div class="pagination pr">
            <Pagination
              background
              @current-change="get_order"
              :page-size="10"
              layout="total, prev, pager, next"
              :total="orderData.total"
            >></Pagination>
          </div>
        </div>
      </div>
    </div>
    <!--底部信息-->
    <div class="bottombox">
      <commonbottom />
    </div>
    <!--公共底部-->
    <commonfoot />
    <!--公共底部-->
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import commonbottom from "../common/common_bottom";
import { Table, TableColumn, Button, Pagination } from "element-ui";
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    Table,
    TableColumn,
    Button,
    Pagination,
    commonbottom,
  },
  data: function() {
    return {
      orderData: "",
      head_style:{
        background:'rgba(28, 154, 244, 0.1)',
        color:'rgba(40,40,40,1)',
        'text-align':'center',
        'font-size': '20px',        
        'font-family': 'PingFang',
        'font-weight': '500',
        'padding': '0',
        'line-height': '50px'
      },
      cell_style:{
        color:'#666',
        'text-align':'center',
        'font-size': '16px',        
        'font-family': 'PingFang',
        'font-weight': '500',
        'padding': '20px 0',
        'line-height': '76px',
        'border-bottom-color': '#eee' 
      },
      now: null,
      seconds: 0,
      timer: null
    };
  },
  mounted: function() {
    this.get_order(1);
  },
  methods: {
    handleEdit(index, row) {
      window.console.log(index, row);
    },
    pay_now(order_id,is_paid) {
      this.$router.push("./user-order-details?order_id=" + order_id+"&is_paid="+is_paid);
    },
    get_order(page) {
      //获取订单列表
      let self = this;
      if(this.timer){
        clearInterval(this.timer);
      }
      common.requestFun(
        self,
        "get",
        "/student/orders",
        {
          page: page
        },
        res => {
          if (res.data.code == 200) {
            self.orderData = res.data.data;
            self.timer = setInterval(()=>{
              self.now = new Date().getTime();  
            },1000)
          }
        }
      );
    },
    deal_goods(type) {
      switch (type) {
        case 8:
          return "至尊VIP";
          break;
        case 6:
          return "钻石VIP";
          break;
        case 5:
          return "黄金VIP";
          break;
        case 4:
          return "白银VIP";
          break;
        case 3:
          return "普通会员";
          break;
        case 2:
          return "课程";
          break;
      }
    },
    authcallback(isLogin){
      if(!isLogin){
          this.$message({
              message: "请登录",
              type: "error",
              center: true
          });
          this.$router.push("./");
      }
    },
  }
};
</script>
<style scoped src="./user_center_order.css"></style>
